import { useState } from 'react';
import { useClassesTable } from '../../../../components/Classes/hooks/useClassesTable';
import { ClassesModal } from '../../../../components/Classes/Modals/ClassesModal';
import { InheritClassesModal } from '../../../../components/Classes/Modals/InheritClassesModal';
import { SettingsClassesTable } from '../../../../components/Classes/Tables/SettingsClassesTable';
import { Page } from '../../../../components/Page/Page';
import { useDeleteClasses } from '../../../../hooks/useDeleteClasses';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { showSuccessDeleteToast, showUserDbErrorToast } from '../../../../utils/toast';

export const SettingsClassesPage = () => {
  const permissions = usePermissionChecker();

  const { deleteClass } = useDeleteClasses();

  const { DeleteDialog, confirmDelete } = useClassesTable();

  const [classesModalOpen, setClassesModalOpen] = useState<boolean>(false);
  const [inheritModalOpen, setInheritModalOpen] = useState<boolean>(false);
  const [classUuid, setClassUuid] = useState<null | string>(null);
  const [loading, setLoading] = useState<boolean>(false);

  function handleAdd() {
    setClassUuid(null);
    setClassesModalOpen(true);
  }

  function handleEdit(uuid: string) {
    setClassUuid(uuid);
    setClassesModalOpen(true);
  }

  function handleInherit(open: boolean) {
    setInheritModalOpen(open);
  }

  async function handleDelete(uuid: string) {
    const confirmResult = await confirmDelete();
    setLoading(true);
    if (confirmResult) {
      const { error } = await deleteClass(uuid);
      if (error) {
        showUserDbErrorToast();
      } else {
        showSuccessDeleteToast();
      }
    }
    setLoading(false);
  }
  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <SettingsClassesTable
        loading={loading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onInherit={() => handleInherit(true)}
        onDelete={handleDelete}
      />

      <ClassesModal
        classUuid={classUuid}
        isOpen={classesModalOpen}
        onClose={() => {
          setClassUuid(null);
          setClassesModalOpen(false);
        }}
      />

      <InheritClassesModal isOpen={inheritModalOpen} onClose={() => handleInherit(false)} />

      <DeleteDialog />
    </Page>
  );
};
